import type { CityConfig } from "../city-template/types";

export const mandanConfig: CityConfig = {
  city: "Mandan",
  state: "North Dakota",
  stateAbbr: "ND",
  slug: "mandan",
  route: "/cities/mandan",
  title: "Emergency Passport Mandan, ND — Expedited Same-Day Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Mandan, ND — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Mandan, Morton County, Bismarck-Mandan metro, and Missouri River communities. No Minneapolis trip needed.",
  h1: "Emergency & Expedited Passport Services in Mandan, ND",
  heroSubtitle: "State government employee heading to an international conference? Morton County family planning a once-in-a-lifetime trip? Missouri River outdoorsman heading to Canada for a fishing expedition? We help Mandan residents — from state workers commuting across the river to Bismarck to families in the growing Lakewood and Mandan Heights neighborhoods — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30-100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20Mandan%20North%20Dakota%20skyline%20along%20the%20Missouri%20River%20with%20the%20historic%20Fort%20Abraham%20Lincoln%20area%20in%20the%20distance%2C%20the%20Mandan%20Railroad%20Museum%20and%20downtown%20historic%20district%2C%20bluffs%20and%20river%20valley%20landscape%2C%20dramatic%20North%20Dakota%20big%20sky%20at%20golden%20sunset%20hour%20with%20warm%20amber%20light%2C%20editorial%20travel%20photography%20with%20crisp%20detail%20and%20natural%20colors&width=1800&height=700&seq=mandan-hero-2026&orientation=landscape",
  heroImageAlt: "Mandan North Dakota skyline along the Missouri River at golden hour",
  geoPosition: "46.8267;-100.8896",
  geoPlacename: "Mandan, North Dakota",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "Minneapolis Passport Agency",
    address: "212 3rd Ave S, Suite 200, Minneapolis, MN 55401",
    distance: "Nearest regional passport agency — located approximately 440 miles from Mandan; about a 6.5-hour drive",
  },
  nearbyCitiesZips: [
    { name: "Mandan", zips: "58554" },
    { name: "Bismarck", zips: "58501, 58503, 58504" },
    { name: "Lincoln", zips: "58504" },
    { name: "New Salem", zips: "58563" },
    { name: "Glen Ullin", zips: "58631" },
    { name: "Flasher", zips: "58535" },
    { name: "Hebron", zips: "58638" },
  ],
  benefits: [
    { icon: "ri-government-line", title: "State Government & Capitol Access", desc: "Mandan is minutes from the North Dakota State Capitol in Bismarck. State employees traveling internationally for government business, legislative exchanges, and trade missions need fast passport processing — and we deliver without requiring a Minneapolis trip." },
    { icon: "ri-building-2-line", title: "Bismarck-Mandan Metro Advantage", desc: "As part of the Bismarck-Mandan metropolitan area, Mandan residents benefit from BIS airport access (15 minutes away) and the full range of metro services — while enjoying Mandan's distinct community character and lower cost of living." },
    { icon: "ri-ship-line", title: "Missouri River Recreation Hub", desc: "Mandan sits along the Missouri River, a hub for boating, fishing, and outdoor recreation. Canadian fishing expeditions and international adventure travel are popular among Mandan's outdoor community — creating steady passport demand." },
    { icon: "ri-history-line", title: "Fort Abraham Lincoln Heritage", desc: "Mandan's rich history — from the Mandan tribes that gave the city its name to Fort Abraham Lincoln and Custer's legacy — attracts international visitors and inspires Mandan residents to explore the world in return." },
  ],
  internalLinks: [
    { name: "Expedited passport in Bismarck, ND", route: "/cities/bismarck" },
    { name: "Fast passport services in Dickinson, ND", route: "/cities/dickinson" },
    { name: "Quick passport services in Fargo, ND", route: "/cities/fargo" },
    { name: "Urgent passport services in Minot, ND", route: "/cities/minot" },
    { name: "North Dakota passport services overview", route: "/states/north-dakota" },
  ],
  fpcOfficeAddress: "212 3rd Ave S, Suite 200, Minneapolis, MN 55401",
  fpcOfficeNote: "Fast Passport Center serves Mandan via secure registered courier with direct access to the Minneapolis Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 6.5+ hours to Minnesota. Mandan residents can ship from any UPS Store, FedEx Office, or post office location across the Bismarck-Mandan metro.",
  fpcOfficeDistance: "Serving Mandan, Lincoln, New Salem, Glen Ullin, Flasher, Hebron, and all Morton County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Mandan and the Missouri River valley. From the historic downtown and Fort Abraham Lincoln area to the growing neighborhoods of Lakewood and Mandan Heights, from Morton County families to state government employees — we serve all of Mandan. Our courier service eliminates the need to drive 440 miles to Minneapolis for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Mandan and all Morton County communities including Lincoln, New Salem, and Glen Ullin. As part of the Bismarck-Mandan metropolitan area, we also coordinate closely with the state capital community for travelers who live in Mandan and work in Bismarck.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Mandan as simple as possible — with the reliability Missouri River communities deserve. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Mandan travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Mandan's position across the river from the state capital creates unique passport situations — state employees with short-notice international travel, Morton County families planning big trips, and Missouri River outdoor enthusiasts heading to Canada. Here are the most common mistakes we see.",
  testimonialsIntro: "Mandan travelers — from state government employees to Morton County families to Missouri River adventurers — trust us when international travel deadlines arrive and Minneapolis is simply too far.",
  faqIntro: "Have questions about expedited passports in Mandan, ND? Here are the most common ones we hear from our neighbors along the Missouri River.",
  statePageRoute: "/states/north-dakota",
  statePageName: "North Dakota",
  servicesIntro: "Whether you're a state employee needing a passport for an international trade mission, a Morton County family planning a dream vacation, or a Missouri River fisherman heading to Canada — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30-100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.dot.nd.gov/divisions/driverslicense/driverslicense.htm",
  dmvLabel: "North Dakota Department of Transportation — Driver License Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Minneapolis agency is 440 miles from Mandan", "6.5+ hour drive — takes a full day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2-9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Minneapolis trip needed", "Ideal for state employees and families", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3-5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1-3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with government shutdowns", "In-person clerk appointment required in Mandan or Bismarck", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "State government trade mission leaving in 3 days? Family emergency overseas requiring immediate travel? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Mandan travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Mandan residents renew fast — no agency visit required for most renewals. Perfect for state employees, Morton County families, and Missouri River adventurers.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Morton County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed so your BIS departure or international plans aren't derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Mandan family vacation stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations and IDs.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for state trade representatives traveling while primary passport is in visa processing, and Morton County business owners with overlapping international commitments.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Missouri River mishaps happen — water damage to a passport is more common than you'd think. We help Mandan residents replace damaged passports quickly.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, and the Caribbean. Ideal for Mandan residents heading to Manitoba and Saskatchewan for fishing and recreation.",
      bullets: ["Wallet-size convenience", "Land crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Mandan ND", description: "Urgent passport processing for Mandan North Dakota travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Mandan ND", description: "Fast passport renewal for Mandan North Dakota residents." },
    { name: "First-Time Passport Mandan ND", description: "New passport application services for Mandan North Dakota first-time applicants." },
    { name: "Child Passport Mandan ND", description: "Minor passport services for Mandan North Dakota families with children under 16." },
    { name: "Name Change Passport Mandan ND", description: "Passport name correction for Mandan residents after marriage or legal name changes." },
    { name: "Second Passport Mandan ND", description: "Second passport services for Mandan frequent travelers and state employees." },
  ],
  testimonials: [
    {
      name: "Tom B.",
      location: "Mandan",
      rating: 5,
      text: "I work at the North Dakota Department of Commerce and got tapped for a trade mission to Germany with 2 weeks' notice. My passport was buried in a drawer — expired by 8 months. Fast Passport Center renewed it in 5 days. Made the trade mission and closed a deal for a ND ag exporter.",
      service: "Expedited Passport Renewal — Government Travel",
    },
    {
      name: "The Peterson Family",
      location: "Mandan",
      rating: 5,
      text: "We've lived in Mandan Heights for 15 years and finally planned the big family trip to Italy. Three weeks before departure, we discovered our 16-year-old's passport was expired. Fast Passport Center expedited the renewal and saved the trip. The Colosseum was incredible.",
      service: "Child Passport Renewal — Family Vacation",
    },
    {
      name: "Dan R.",
      location: "Mandan",
      rating: 5,
      text: "Annual fishing trip to Lake Winnipeg with my buddies — a tradition for 20 years. Realized my passport card was expired 5 days before we were supposed to leave. Fast Passport Center expedited a passport book that arrived day 4. Caught a 32-inch walleye. Legendary.",
      service: "Expedited Passport — Canada Recreation",
    },
    {
      name: "Linda W.",
      location: "Lincoln",
      rating: 5,
      text: "My daughter's destination wedding in Cancun — 40 family members going. My husband and I realized our passports were expired when the travel agent asked for numbers. With 3 weeks to go, Fast Passport Center renewed both in under a week. We danced on the beach.",
      service: "Passport Renewal — Destination Wedding",
    },
  ],
  facilities: [
    {
      id: "mandan-1",
      name: "Mandan Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 Collins Ave",
      city: "Mandan",
      state: "ND",
      zip: "58554",
      phone: "(701) 663-7211",
      hours: "Mon-Fri 9:00 AM - 3:30 PM (appointment required)",
      distance: "Downtown Mandan",
      website: "https://tools.usps.com/find-location.htm?location=1378245",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Mandan and Morton County. Passport photos available on-site. Appointment recommended — limited slots during summer travel season.",
      icon: "ri-mail-line",
    },
    {
      id: "mandan-2",
      name: "Bismarck Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "220 E Rosser Ave",
      city: "Bismarck",
      state: "ND",
      zip: "58501",
      phone: "(701) 221-6505",
      hours: "Mon-Fri 8:30 AM - 5:00 PM (appointment required)",
      distance: "Downtown Bismarck — about 7 miles from Mandan across the Missouri River",
      website: "https://tools.usps.com/find-location.htm?location=1372838",
      websiteLabel: "USPS Location",
      notes: "Largest acceptance facility in the Bismarck-Mandan metro. More appointment availability than Mandan office. Full passport photo service. About 15-minute drive from Mandan.",
      icon: "ri-mail-line",
    },
    {
      id: "mandan-3",
      name: "Morton County Clerk of Court",
      type: "County Clerk Passport Acceptance",
      address: "210 2nd Ave NW",
      city: "Mandan",
      state: "ND",
      zip: "58554",
      phone: "(701) 667-3350",
      hours: "Mon-Fri 8:00 AM - 4:30 PM",
      distance: "Downtown Mandan — Morton County Courthouse",
      website: "https://www.mortonnd.org/",
      websiteLabel: "Morton County Website",
      notes: "Alternative to post office acceptance. Appointment recommended. Does not offer photo services — bring your own passport photo or get one at the Mandan Post Office first.",
      icon: "ri-government-line",
    },
    {
      id: "mandan-4",
      name: "Burleigh County Clerk of Court",
      type: "County Clerk Passport Acceptance",
      address: "514 E Thayer Ave",
      city: "Bismarck",
      state: "ND",
      zip: "58501",
      phone: "(701) 222-6683",
      hours: "Mon-Fri 8:00 AM - 5:00 PM",
      distance: "Bismarck — about 8 miles from Mandan",
      website: "https://www.burleighco.com/",
      websiteLabel: "Burleigh County Website",
      notes: "Additional acceptance option across the river in Bismarck. Appointment recommended. Does not offer photo services.",
      icon: "ri-government-line",
    },
    {
      id: "mandan-5",
      name: "New Salem Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "315 N 3rd St",
      city: "New Salem",
      state: "ND",
      zip: "58563",
      phone: "(701) 843-7421",
      hours: "Mon-Fri 9:00 AM - 3:00 PM (appointment required)",
      distance: "New Salem — about 35 miles west of Mandan on I-94",
      website: "https://tools.usps.com/find-location.htm?location=1378937",
      websiteLabel: "USPS Location",
      notes: "Serves western Morton County residents. Home of the world's largest Holstein cow statue — Salem Sue. Small facility; call ahead for passport acceptance hours.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Minneapolis Passport Agency, 440 miles and 6.5+ hour drive from Mandan", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Minneapolis; takes a full day and likely an overnight from Mandan", fpc: "Most Mandan travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — impractical from Mandan", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Mandan", agency: "440-mile drive — full day trip; impractical for most residents", fpc: "Entirely remote — forms online, ship from Mandan, passport arrives at your door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof of travel", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but factoring in travel to Minneapolis, time off work", fpc: "Best price guarantee — 30-100% less than FedEx, Staples and resellers" },
    { feature: "Mandan Context", agency: "No local guidance — no state government, Missouri River, or Morton County expertise", fpc: "Full Mandan knowledge — state employees, BIS airport, outdoor recreation, family travel" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "State Government Employee Travel Timing",
      description: "Mandan is home to many state employees whose international travel — trade missions, legislative exchanges, and conferences — often materializes with short notice. Government travel approvals can take weeks, leaving only days for passport processing. We recommend state employees maintain current passports proactively.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missouri River Recreation Passport Damage",
      description: "Boating, fishing, and camping along the Missouri River expose passports to water, mud, and physical damage. A water-damaged passport is considered mutilated by the State Department and must be replaced. We see this regularly from Mandan's outdoor community.",
    },
    {
      icon: "ri-error-warning-line",
      title: "BIS Airport Passport Assumptions",
      description: "Bismarck Airport is 15 minutes from Mandan and most international travelers connect through Minneapolis or Denver. Mandan residents often assume their passport only matters at the international gateway — but BIS check-in agents verify passport validity before you board your first flight.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Mandan vs. Bismarck Service Confusion",
      description: "Living in Mandan but working in Bismarck means some residents use Bismarck addresses for mail and services. This creates confusion about which county's vital records to request and which acceptance facility to use. We clarify county-specific requirements for Morton County residents.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Canada Fishing Trip Passport Cards",
      description: "Canadian fishing trips from Mandan are popular — Lake Winnipeg, Lake of the Woods, and Saskatchewan fly-in lodges. Many fishermen assume a passport card is sufficient, but some fly-in lodges require a passport book for air travel within Canada. We help Mandan anglers get the right document for their specific trip.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether it's a state trade mission, family vacation, or Canadian fishing trip." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist — whether you're a Morton County family or a state employee commuting across the river." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send documents using overnight shipping. Most Mandan clients ship from the UPS Store on Memorial Highway or the Mandan Post Office — no Minneapolis trip needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our center. We submit through reserved agency slots — so Mandan travelers never need to drive 440 miles to Minneapolis." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is shipped directly to your Mandan address — whether that's in Mandan Heights, Lakewood, or downtown. No agency visit. No Minneapolis. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Mandan, North Dakota?", a: "We offer Mandan area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5-10 business days. Because the nearest regional passport agency is in Minneapolis (440 miles away), our remote courier service is the most practical fast option for the Bismarck-Mandan metro." },
    { q: "Do I need to visit a Mandan office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Mandan Post Office, Morton County Clerk, or Bismarck Main Post Office), then ship documents overnight. We handle State Department submission and return your passport to your Morton County address." },
    { q: "Can state government employees get expedited passports for trade missions?", a: "Yes. Mandan is home to many North Dakota state employees who travel internationally for trade missions, legislative exchanges, and government conferences. These trips often have short notice — we process expedited passports to meet government travel deadlines." },
    { q: "What if I need a passport and Minneapolis is too far?", a: "Minneapolis Passport Agency is 440 miles from Mandan — a 6.5+ hour drive through Minnesota. That's a full day of travel each way. Our registered courier service handles the agency submission remotely, so you never leave the Bismarck-Mandan area." },
    { q: "What is the best price for expedited passport service in Mandan?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30-100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "What documents do Mandan applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos." },
    { q: "Can I get a passport photo in Mandan?", a: "Yes. The Mandan Post Office offers on-site passport photos. Walgreens and Walmart in Bismarck also provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression. Many Mandan residents use the Bismarck Main Post Office for photos since it offers full service." },
    { q: "Can you help with passports for Canadian fishing trips from Mandan?", a: "Yes. Mandan's outdoor community regularly travels to Manitoba and Saskatchewan for fishing, hunting, and recreation. We process both passport books and passport cards. Important: if your fishing trip involves flying within Canada (e.g., to a fly-in lodge), you'll need a passport book — passport cards are only valid for land and sea entry." },
    { q: "How does BIS airport affect passport timing for Mandan residents?", a: "Bismarck Airport is 15 minutes from Mandan. Airlines verify passport validity at BIS check-in — not at your Minneapolis or Denver connection. If your passport is expired, you won't board at Bismarck. Always verify your passport is valid before heading to BIS." },
    { q: "I live in Mandan but my mailing address is Bismarck — which county's services should I use?", a: "Your physical residence determines your county — if you live in Mandan, you're in Morton County. Use Morton County vital records for marriage and divorce certificates. For acceptance facilities, you can use either Mandan or Bismarck offices — whichever is more convenient. We'll guide you through any county-specific requirements." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Mandan Residents",
    intro: "Mandan's position on the Missouri River — across from the state capital and part of the Bismarck-Mandan metro — creates a unique travel profile. Here's what Mandan residents need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "BIS — Bismarck Airport",
        subtitle: "The metro's air gateway, 15 minutes from Mandan",
        description: "BIS serves the Bismarck-Mandan metro with daily flights to Minneapolis, Denver, Dallas, and seasonal routes. Most Mandan international travelers connect through Minneapolis (MSP) or Denver (DEN) for overseas flights. The airport is just 15 minutes from Mandan — making international travel accessible from your doorstep.",
        tip: "BIS check-in agents verify passport documents before you board your first flight. If your passport has issues, you'll find out at the Bismarck counter — not at your international connection. Check your passport before leaving Mandan.",
      },
      {
        icon: "ri-government-line",
        title: "State Capitol International Travel",
        subtitle: "Government employees with unpredictable timelines",
        description: "Many Mandan residents work at the North Dakota State Capitol in Bismarck. International trade missions, legislative exchanges, and government conferences create passport needs that often materialize with just 2-4 weeks' notice. State employees need fast passport processing that doesn't require leaving North Dakota.",
        tip: "State employees who may travel internationally should maintain valid passports proactively. Government travel approvals can take weeks — leaving passport processing as the final, most time-sensitive step. A current passport eliminates this bottleneck.",
      },
      {
        icon: "ri-ship-line",
        title: "Missouri River Recreation & Canadian Adventures",
        subtitle: "Mandan's outdoor community goes international",
        description: "Mandan's identity is tied to the Missouri River — boating, fishing, and outdoor recreation are woven into community life. This outdoor culture naturally extends north to Canada, with popular destinations including Lake Winnipeg, Lake of the Woods, and Saskatchewan fly-in fishing lodges. Canadian outdoor adventures create steady, seasonal passport demand.",
        tip: "Canadian fishing and hunting trips require specific documentation. Passport cards work for driving across the border, but passport books are needed for any air travel within Canada (including fly-in lodges). We help Mandan sportsmen get the right document for their specific trip.",
      },
      {
        icon: "ri-home-smile-line",
        title: "Growing Morton County Families",
        subtitle: "Mandan's residential growth creates new passport needs",
        description: "Mandan's neighborhoods — Lakewood, Mandan Heights, and new developments along the river — are attracting families seeking more space while staying close to Bismarck jobs. These growing families are planning big trips: Disney vacations, European heritage tours, destination weddings, and visits to relatives abroad. First-time passports for children are among our most common requests from Mandan.",
        tip: "Mandan families planning international trips should check every family member's passport well in advance. Children's passports are valid for only 5 years (vs. 10 for adults), and many parents discover expired child passports too close to departure.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Mandan & the Missouri River Crossing",
      description: "The Missouri River defines Mandan's geography — separating it from Bismarck while connecting it through the historic Memorial Bridge and Expressway Bridge. This river crossing is a daily ritual for thousands of Mandan-to-Bismarck commuters and symbolizes Mandan's dual identity: a distinct community with its own character, seamlessly connected to the opportunities of the state capital.",
    },
  },
  destinations: {
    title: "Where Mandan Travelers Go — And Why Passports Get Urgent",
    intro: "Mandan's state government workforce, outdoor recreation culture, and growing family community shape its international travel patterns.",
    stats: [
      { stat: "25%", label: "of Mandan expedited requests involve state government international travel" },
      { stat: "3-5 Weeks", label: "average lead time for Morton County family international trips" },
      { stat: "Jun-Aug", label: "peak season for family vacations and Canadian outdoor adventures" },
      { stat: "440 Miles", label: "distance to nearest passport agency — our courier keeps you in ND" },
    ],
    destinations: [
      { name: "Canada", context: "Manitoba and Saskatchewan fishing trips, Winnipeg weekend getaways, hunting expeditions, Canadian Rockies adventures", urgency: "May-September peak season for outdoor recreation travelers", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "State government trade missions, Morton County family heritage trips to Germany, Norway, and Ireland, river cruise vacations", urgency: "Government travel with short notice; family trips with 3-6 month planning", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "Winter escapes from North Dakota cold, destination weddings, all-inclusive resort vacations, cruise departures", urgency: "Fall and winter bookings as families plan warm getaways", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "State agricultural trade missions to China and Japan, North Dakota exports and business development, family visits to relatives abroad", urgency: "Government and business timelines — typically 3-6 weeks", icon: "ri-map-pin-2-line" },
      { name: "Central & South America", context: "State trade partnerships, eco-tourism and adventure travel, medical mission trips from the Bismarck-Mandan community", urgency: "Mixed timelines depending on trip purpose", icon: "ri-map-pin-2-line" },
      { name: "Australia & New Zealand", context: "Once-in-a-lifetime family adventures, state agricultural exchange programs, outdoor enthusiasts exploring southern hemisphere destinations", urgency: "Long-haul trips with extensive planning — passport issues often found late", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other North Dakota Service Areas",
    crossLinksDesc: "We serve travelers across the Peace Garden State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Bismarck", route: "/cities/bismarck" },
      { name: "Dickinson", route: "/cities/dickinson" },
      { name: "Fargo", route: "/cities/fargo" },
    ],
  },
  photoLocations: [
    { name: "Mandan Post Office", address: "300 Collins Ave, Mandan, ND 58554", hours: "Mon-Fri 9 AM - 3:30 PM (photo service available)" },
    { name: "Bismarck Main Post Office", address: "220 E Rosser Ave, Bismarck, ND 58501", hours: "Mon-Fri 8:30 AM - 5 PM (full photo service)" },
    { name: "Walmart Supercenter — Bismarck", address: "1401 Skyline Blvd, Bismarck, ND 58503", hours: "Daily 6 AM - 11 PM" },
    { name: "Walgreens — Bismarck", address: "711 E Bismarck Expy, Bismarck, ND 58504", hours: "Daily 8 AM - 10 PM" },
    { name: "The UPS Store — Bismarck", address: "1140 College Dr, Bismarck, ND 58501", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "North Dakota DOT — Bismarck Driver License Office",
      address: "608 E Boulevard Ave, Bismarck, ND 58505",
      hours: "Mon-Fri, 8:00 AM - 4:45 PM (appointment recommended)",
      note: "Driver licenses, REAL ID, vehicle registration. Located at the State Capitol complex. Primary office serving Mandan and Morton County. About 10 minutes from Mandan.",
      featured: true,
    },
    {
      name: "Morton County Treasurer — Motor Vehicle",
      address: "210 2nd Ave NW, Mandan, ND 58554",
      hours: "Mon-Fri, 8:00 AM - 4:30 PM",
      note: "Vehicle registration and title services for Morton County. For driver licenses, visit the ND DOT office at the Capitol.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BIS",
      name: "Bismarck Airport",
      distance: "About 15 minutes from Mandan",
      address: "2301 University Dr, Bismarck, ND 58504",
      note: "Serves the Bismarck-Mandan metro with daily flights to Minneapolis, Denver, Dallas, and seasonal routes. Primary air gateway for Mandan residents connecting to international flights. Just 15 minutes from any Mandan neighborhood.",
      flightUrl: "https://www.bismarckairport.com/",
      flightLabel: "Bismarck Airport Website",
      featured: true,
    },
    {
      code: "DIK",
      name: "Dickinson Theodore Roosevelt Regional Airport",
      distance: "About 100 miles west of Mandan (1 hour 30 minutes via I-94)",
      address: "1130 113th Ave SW, Dickinson, ND 58601",
      note: "Alternative regional airport with United flights to Denver. Useful for Mandan residents in western Morton County or when BIS flights are limited.",
      flightUrl: "https://www.dickinsonairport.com/",
      flightLabel: "Dickinson Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified North Dakota birth certificates from the ND Department of Health Vital Records. Online, mail, or in-person options available in Bismarck — just across the river.",
      url: "https://www.health.nd.gov/vital-records",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through ND Department of Health Vital Records. Required for estate and legal matters in Morton County.",
      url: "https://www.health.nd.gov/vital-records",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Morton County Clerk of Court. Certified copies available for name changes and passport applications.",
      url: "https://www.mortonnd.org/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Morton County District Court. Required for name change passport corrections.",
      url: "https://www.mortonnd.org/",
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
};